import { styled } from "styled-components";

export const Wrapper = styled.section`
  h3 {
    text-align: center;
  }
  .skills-container {
    background-color: var(--white);
    width: 100%;
    border-radius: var(--borderRadius);
    display: grid;
    grid-auto-columns: 1fr;
    grid-auto-rows: auto;
    gap: 2.5rem;
    padding: 2rem;
    @media screen and (max-width: 700px) {
      padding: 1rem;
    }
  }
`;
